/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Quote_FailedInputs */

const vi_carrier_form_quote_failed = /** @type {(inputs: Carrier_Form_Quote_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không lấy được báo giá từ hãng`)
};

/**

* @param {Carrier_Form_Quote_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_quote_failed = /** @type {((inputs?: Carrier_Form_Quote_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Quote_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_quote_failed(inputs)
});